import type { CloverTerminalSaleRequestDetails } from './clover-terminal-sale.types';

export const CloverLifecyclePreflightGatewayOperation = {
    TERMINAL_SALE: 'terminal_sale',
} as const;

export type CloverLifecyclePreflightGatewayOperation =
    (typeof CloverLifecyclePreflightGatewayOperation)[keyof typeof CloverLifecyclePreflightGatewayOperation];

export const CloverLifecyclePreflightPayloadType = {
    REQUEST: 'clover_lifecycle_preflight_request_v1',
    RESPONSE: 'clover_lifecycle_preflight_response_v1',
} as const;

export type CloverLifecyclePreflightPayloadType =
    (typeof CloverLifecyclePreflightPayloadType)[keyof typeof CloverLifecyclePreflightPayloadType];

export const CloverLifecyclePreflightOutcome = {
    RECORDED: 'recorded',
    REJECTED: 'rejected',
    MALFORMED_INPUT: 'malformed_input',
} as const;

export type CloverLifecyclePreflightOutcome =
    (typeof CloverLifecyclePreflightOutcome)[keyof typeof CloverLifecyclePreflightOutcome];

export interface CloverLifecyclePreflightRequestDetails {
    readonly gateway_operation: typeof CloverLifecyclePreflightGatewayOperation.TERMINAL_SALE;
    readonly terminal_sale_request_details: CloverTerminalSaleRequestDetails;
}

export interface CloverLifecyclePreflightNormalizedResult {
    readonly gateway_operation: typeof CloverLifecyclePreflightGatewayOperation.TERMINAL_SALE;
    readonly device_id: string;
    readonly amount: number;
    readonly external_payment_id: string;
    readonly final: true;
    readonly capture?: true;
    readonly external_reference_id?: string;
    readonly tip_amount?: number;
}

export type CloverLifecyclePreflightResponseDetails =
    | {
          readonly outcome: typeof CloverLifecyclePreflightOutcome.RECORDED;
          readonly normalized_result: CloverLifecyclePreflightNormalizedResult;
      }
    | {
          readonly outcome: typeof CloverLifecyclePreflightOutcome.REJECTED;
          readonly message: string;
      }
    | {
          readonly outcome: typeof CloverLifecyclePreflightOutcome.MALFORMED_INPUT;
          readonly message: string;
          readonly body: unknown;
      };

export interface CloverLifecyclePreflightRequestPayload {
    readonly gateway_lifecycle_payload_type: typeof CloverLifecyclePreflightPayloadType.REQUEST;
    readonly request_details: CloverLifecyclePreflightRequestDetails;
}

export interface CloverLifecyclePreflightResponsePayload {
    readonly gateway_lifecycle_payload_type: typeof CloverLifecyclePreflightPayloadType.RESPONSE;
    readonly response_details: CloverLifecyclePreflightResponseDetails;
}

export type CloverLifecyclePreflightPayload =
    | CloverLifecyclePreflightRequestPayload
    | CloverLifecyclePreflightResponsePayload;
